'use client';

import {useRef} from 'react';

import {AppsSelectionWithoutContent, SelectionApp} from '@web-catalog/types';

import {useIsGamesPage} from '@web-catalog/hooks';

import {Scroller} from '@web-catalog/ui-kit/Scroller';

import {
  useLogCompilationSwipe,
  useLogOnCompilationShow,
} from '@web-catalog/utils/analytics/interestingPage';
import {useAppCardAnalytics} from '@web-catalog/utils/analytics/useAppCardAnalytics';
import {
  getFeaturingAnalyticsType,
  useFeaturingAnalytics,
} from '@web-catalog/utils/analytics/useFeaturingAnalytics';

import {AppWithScreenshotsCard} from './AppWithScreenshotsCard';
import styles from './SelectionWithScreenshots.module.scss';

type Props = {
  selection: AppsSelectionWithoutContent;
  apps: SelectionApp[];
  displayedSelectionNumber: number;
  isRatingEnabled?: boolean;
};

export const SelectionWithScreenshots = ({
  selection,
  apps,
  displayedSelectionNumber,
  isRatingEnabled,
}: Props) => {
  const ref = useRef(null);

  useLogOnCompilationShow({
    ref,
    selection,
    selectionNumber: displayedSelectionNumber,
  });
  const isGamesPage = useIsGamesPage();
  const {logAppCategoryAppSelect, logGameCategoryGameSelect} =
    useAppCardAnalytics();
  const {logAppSelect} = useFeaturingAnalytics();
  const onSwipe = useLogCompilationSwipe(selection, displayedSelectionNumber);

  const onClick = (app: SelectionApp, index: number) => {
    logAppSelect(
      app,
      index + 1,
      selection.id,
      selection.title?.value,
      getFeaturingAnalyticsType(selection.type, selection.displayType),
    );
    if (isGamesPage) {
      logGameCategoryGameSelect(app.packageName, 'main');
    } else {
      logAppCategoryAppSelect(app.packageName, 'main');
    }
  };

  return (
    <section ref={ref} data-testid="selection_with_app_cards">
      <h2>{selection.title?.value}</h2>
      <Scroller onSwipe={onSwipe}>
        {apps.map((app, index) => (
          <AppWithScreenshotsCard
            key={app.packageName}
            app={app}
            className={styles.card}
            onClick={() => onClick(app, index)}
            isRatingEnabled={isRatingEnabled}
          />
        ))}
      </Scroller>
    </section>
  );
};
